// extracted by mini-css-extract-plugin
var _1 = "_stockOutTable-module__gold-row";
export { _1 as "gold-row" }
